import styled from '@emotion/styled'
import { Paragraph } from 'components/patterns'

export const StyledParamList = styled.ul``

export const StyledParagraph = styled(Paragraph)((props) => {
  const { paragraphColor } = props.theme.color

  return `
    margin-top: 16px;
    margin-bottom: 3px;
    color: ${paragraphColor};
  `
})

// Label styling for ECP: 12px bold, Black Secondary
export const StyledEcpLabel = styled.div`
  margin-top: 20px;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.color.blackSecondary};
`

// Body text styling for ECP: 12px regular, Black Secondary
export const StyledEcpBodyText = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${({ theme }) => theme.color.blackSecondary};
`

export const StyledRefreshIcon = styled.div`
  position: relative;
  top: 2px;
  left: 5px;
  display: inline-block;
`

export const ListLogicItem = styled.li`
  list-style: none;
`
